import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"icon-slider--left\"><path d=\"M5.142 11.213a.908.908 0 0 0 1.486-.291.91.91 0 0 0-.199-.995L3.497 6.994l9.36-.013a.909.909 0 0 0-.005-1.818l-9.383.009 2.955-2.955A.909.909 0 1 0 5.138.93L.641 5.43a.91.91 0 0 0 .003 1.287l4.498 4.497Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol